import React from 'react'
import GridSearchTemplate from '../../../pages/GridSearchTemplate'
import HotelsDropDown from '../../shared/HotelsDropDown'
import { GetAddonsByReservationReport } from '../../../api/services/finance'
import { DatePicker } from '../../shared/DatePicker'
import { Form } from 'semantic-ui-react'
import { useTextResources } from '../../../language'
import moment from 'moment'
import { endpoint } from '../../../api/http'
import { dateFormat } from '../../shared/constants'

const AddonsByReservationReport = () => {
    const text = useTextResources()
    const formatter = ({ value }) => {
        return value ? value.toFixed(2) : 0.00
    }

    const dateFormatter = ({ value }) => {
        return value && moment(value).format(dateFormat)
    }
    /* eslint-disable react/prop-types */
    const reservationFormatter = ({ value, row }) => {
        return <a target="_blank" rel="noopener noreferrer" href={`${endpoint}PMS/Reservations/Index/${row.ReservationId}?hotelid=${row.HotelId}`}>{value}</a>
    }
    /* eslint-enable react/prop-types */
    const gridOptions = {
        search: {
            title: text("AddonsByReservationReportTitle"),
            description: text("AddonPricesPerReservation"),
            fields: [
                <DatePicker
                    type="basic"
                    label={text("StartDate")}
                    name="StartDate"
                    key="StartDate"
                />,
                <DatePicker
                    type="basic"
                    label={text("EndDate")}
                    name="EndDate"
                    key="EndDate"
                />,
                <Form.Field control={HotelsDropDown} width="4" multiple label={text("Hotel")} key="HotelIDs" />
            ],
            api: GetAddonsByReservationReport
        },
        grid: {
            // TODO: Add child amounts
            // TODO: Add totals DONE
            // TODO: Word Wrap in titles
            columns: [
                { name: 'HotelName', title: text('Hotel') },
                { name: 'Name', title: text('AddOn') },
                { name: 'Reservation_Number', title: text('Reservation'), formatter: reservationFormatter },
                { name: 'RoomTypeName', title: text('RoomType') },
                { name: 'Status', title: text('Status') },
                { name: 'Nationality', title: text('Nationality') },
                { name: 'Date', title: text('Date'), formatter: dateFormatter },
                {
                    name: 'AdultQuantity', title: text('Quantity'), exportTitle: `${text('Adult')} ${text('Quantity')}`
                },
                { name: 'AdultAmountBeforeTax', title: text('NotIncTax'), exportTitle: `${text('Adult')} ${text('Price')} ${text('NotIncTax')}`, formatter },
                { name: 'AdultAmountAfterTax', title: text('IncTaxBlock'), exportTitle: `${text('Adult')} ${text('Price')} ${text('IncTaxBlock')}`, formatter },
                { name: 'ChildQuantity', title: text('Quantity'), exportTitle: `${text('Child')} ${text('Quantity')}` },
                { name: 'ChildAmountBeforeTax', title: text('NotIncTax'), exportTitle: `${text('Child')} ${text('Price')} ${text('NotIncTax')}`, formatter },
                { name: 'ChildAmountAfterTax', title: text('IncTaxBlock'), exportTitle: `${text('Child')} ${text('Price')} ${text('IncTaxBlock')}`, formatter },
                { name: 'Quantity', title: text('Quantity'), exportTitle: `${text('Room')} ${text('Quantity')}` },
                { name: 'RoomAmountBeforeTax', title: text('NotIncTax'), exportTitle: `${text('Room')} ${text('Price')} ${text('NotIncTax')}`, formatter },
                { name: 'RoomAmountAfterTax', title: text('IncTaxBlock'), exportTitle: `${text('Room')} ${text('Price')} ${text('IncTaxBlock')}`, formatter },
                { name: 'ComputedTotalBeforeTax', title: text('NotIncTax'), exportTitle: `${text('ComputedTotal')} ${text('NotIncTax')}`, formatter },
                { name: 'ComputedTotalAfterTax', title: text('IncTaxBlock'), exportTitle: `${text('ComputedTotal')} ${text('IncTaxBlock')}`, formatter },
                { name: 'Currency', title: text('Currency') }
            ],
            columnBands: [
                {
                    title: `${text('Adult')} ${text('Price')}`,
                    children: [{ columnName: 'AdultAmountBeforeTax' }, { columnName: 'AdultAmountAfterTax' }, { columnName: 'AdultQuantity' }]
                },
                {
                    title: `${text('Child')} ${text('Price')}`,
                    children: [{ columnName: 'ChildAmountBeforeTax' }, { columnName: 'ChildAmountAfterTax' }, { columnName: 'ChildQuantity' }]
                },
                {
                    title: `${text('Room')} ${text('Price')}`,
                    children: [{ columnName: 'Quantity' }, { columnName: 'RoomAmountBeforeTax' }, { columnName: 'RoomAmountAfterTax' }]
                },
                {
                    title: text('ComputedTotal'),
                    children: [{ columnName: 'ComputedTotalBeforeTax' }, { columnName: 'ComputedTotalAfterTax' }]
                }
            ],
            pdf: true,
            summary: true,
            export: true,
            totalSummaryItems: [
                { columnName: 'AdultAmountBeforeTax', type: 'sum', formatter },
                { columnName: 'AdultAmountAfterTax', type: 'sum', formatter },
                { columnName: 'ChildAmountBeforeTax', type: 'sum', formatter },
                { columnName: 'ChildAmountAfterTax', type: 'sum', formatter },
                { columnName: 'RoomAmountBeforeTax', type: 'sum', formatter },
                { columnName: 'RoomAmountAfterTax', type: 'sum', formatter },
                { columnName: 'ComputedTotalBeforeTax', type: 'sum', formatter },
                { columnName: 'ComputedTotalAfterTax', type: 'sum', formatter }
            ]
        }
    }
    return (<GridSearchTemplate options={gridOptions} />)
}

export default AddonsByReservationReport